/* eslint-disable max-len */
import React from 'react';

const Clock: React.FC<object> = () => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_6222_116669)">
                <path
                    d="M6 0.75C7.30538 0.750001 8.5604 1.23638 9.52344 2.1084L9.71191 2.28809C10.6965 3.27264 11.25 4.60761 11.25 6C11.25 7.30538 10.7636 8.56041 9.8916 9.52344L9.71191 9.71191C8.72739 10.6965 7.3924 11.25 6 11.25C4.69464 11.25 3.43962 10.7636 2.47656 9.8916L2.28809 9.71191L2.1084 9.52344C1.23638 8.5604 0.75 7.30538 0.75 6C0.750001 4.69464 1.23638 3.43962 2.1084 2.47656L2.28809 2.28809C3.27265 1.30352 4.60761 0.75 6 0.75Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
                <path
                    d="M6 3L6 6.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6 6.49959L8.03125 8.125"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_6222_116669">
                    <rect width="12" height="12" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default Clock;